import { render, staticRenderFns } from "./imNotifyDialog.vue?vue&type=template&id=bf3112f2&scoped=true"
import script from "./imNotifyDialog.vue?vue&type=script&lang=js"
export * from "./imNotifyDialog.vue?vue&type=script&lang=js"
import style0 from "./imNotifyDialog.vue?vue&type=style&index=0&id=bf3112f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3112f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf3112f2')) {
      api.createRecord('bf3112f2', component.options)
    } else {
      api.reload('bf3112f2', component.options)
    }
    module.hot.accept("./imNotifyDialog.vue?vue&type=template&id=bf3112f2&scoped=true", function () {
      api.rerender('bf3112f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/upgradePopupManage/components/imNotifyDialog.vue"
export default component.exports